import { useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Layout hideAd>
      <div className="max-w-md mx-auto px-4 py-16" data-testid="forgot-password-page">
        <div className="text-center mb-6">
          <div className="w-12 h-12 rounded-2xl bg-primary flex items-center justify-center text-white font-black text-xl font-display mx-auto mb-3">M</div>
          <h1 className="font-display font-bold text-2xl">Forgot your password?</h1>
          <p className="text-sm text-muted-foreground mt-1">Enter your email and we'll send you a link to reset it.</p>
        </div>

        <div className="p-6 rounded-2xl border border-border/60 bg-card">
          {sent ? (
            <div className="text-center py-4" data-testid="forgot-password-sent">
              <MailCheck className="w-12 h-12 text-green-600 mx-auto mb-3" />
              <h2 className="font-semibold text-lg">Check your inbox</h2>
              <p className="text-sm text-muted-foreground mt-1">If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly. The link expires in 1 hour.</p>
              <Link to="/login"><Button variant="outline" className="rounded-full mt-5" data-testid="back-to-login-btn"><ArrowLeft className="w-4 h-4 mr-2" />Back to sign in</Button></Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
              <div>
                <Label htmlFor="fp-email">Email</Label>
                <Input id="fp-email" data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" />
              </div>
              <Button type="submit" disabled={loading} className="w-full rounded-full" size="lg" data-testid="forgot-submit-btn">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
              </Button>
              <p className="text-center text-sm text-muted-foreground">
                <Link to="/login" className="text-primary font-semibold hover:underline">Back to sign in</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
}
